import {
  ChartCandlestick,
  GitPullRequest,
  History,
  House,
  Landmark,
  ShoppingCart,
  Users,
  FileBox,
  ShieldUser,
  Activity,
  TrendingUp,
  UserCheck,
  CreditCard,
  Globe,
  Gift,
  Clock,
  Logs,
  WalletCards,
  ShoppingBasket,
  FileClock,
  WalletMinimal,
  UserRoundPlus,
  AlignHorizontalDistributeCenter,
  Omega,
  BellRing,
  PackagePlus,
  MapPinHouse,
  PackageSearch,
  Settings,
  Wrench,
  Rocket,
  FileChartColumn,
  TreePalm,
  Coins,
  Banknote,
  BanknoteArrowUp,
  Airplay,
  ChartNoAxesCombined,
  UsersRound,
  ScaleIcon,
  ShieldCheck,
  IdCard,
  ScrollText
} from "lucide-react";
import { SidebarMenuItem } from "../../../utils/interface";

const physicalProductsItem = {
  id: "Physical Products",
  path: "/controls/physical-products",
  label: "Physical Products",
  icon: <TreePalm size={13} />,
  requiredPermission: {
    section: "esouqProducts",
    action: "canView"
  }
}

export const sidebarMenuItems: SidebarMenuItem[] = [
  {
    id: "home",
    path: "/home",
    label: "Home",
    icon: <House size={13} />,
  },
  {
    id: "transaction-stats",
    path: "/transaction-stats",
    label: "Transaction Stats",
    icon: <ChartNoAxesCombined size={13} />,
    requiredPermission: {
      section: "transactionStats",
      action: "canView",
    },
  },
  {
    id: "e-souq-manager",
    label: "E-Souq Manager",
    icon: <PackageSearch size={13} />,
    children: [
      {
        id: "products",
        path: "/e-souq-manager/products",
        label: "Products",
        icon: <PackagePlus size={13} />,
        requiredPermission: {
          section: "esouqProducts",
          action: "canView",
        },
      },
      {
        id: "orders",
        path: "/e-souq-manager/orders",
        label: "Orders",
        icon: <ShoppingCart size={13} />,
        requiredPermission: {
          section: "order",
          action: "canView",
        },
      },
      {
        id: "website-orders",
        path: "/e-souq-manager/website-orders",
        label: "Website Orders",
        icon: <Airplay size={13} />,
        requiredPermission: {
          section: "order",
          action: "canView",
        },
      },
      {
        id: "branches",
        path: "/e-souq-manager/branches",
        label: "Branches",
        icon: <MapPinHouse size={13} />,
        requiredPermission: {
          section: "branches",
          action: "canView",
        },
      },
    ],
  },
  {
    id: "history",
    path: "/history",
    label: "History",
    icon: <History size={13} />,
    requiredPermission: {
      section: "history",
      action: "canView",
    },
  },
  {
    id: "positions",
    path: "/positions",
    label: "Positions",
    icon: <FileBox size={13} />,
    requiredPermission: {
      section: "openPositions",
      action: "canView",
    },
  },
  {
    id: "live-transactions",
    path: "/live-transactions",
    label: "Live Transactions",
    icon: <Activity size={13} />,
    requiredPermission: {
      section: "liveTransaction",
      action: "canView",
    },
  },
  {
    id: "requests",
    label: "Requests",
    icon: <GitPullRequest size={13} />,
    children: [
      {
        id: "withdrawal-request",
        path: "/requests/pending-withdrawal-requests",
        label: "Withdrawal",
        icon: <CreditCard size={13} />,
        requiredPermission: {
          section: "withdrawalsRequests",
          action: "canView",
        },
      },
      // {
      //   id: "loan-request",
      //   path: "/requests/pending-loan-requests",
      //   label: "Loan",
      //   icon: <DollarSign size={13} />,
      //   requiredPermission: {
      //     section: "loanRequests",
      //     action: "canView"
      //   }
      // },
      {
        id: "user-change",
        path: "/requests/user-change-requests",
        label: "User Info",
        icon: <UserCheck size={13} />,
        requiredPermission: {
          section: "clientInfoChangeRequests",
          action: "canView",
        },
      },
    ],
  },
  {
    id: "temporary-credits",
    path: "/temporary-credits",
    label: "Temporary Credits",
    icon: <BanknoteArrowUp size={13} />,
    requiredPermission: {
      section: "history",
      action: "canView",
    },
  },
  {
    id: "reports",
    label: "Reports",
    icon: <Logs size={13} />,
    children: [
      {
        id: "money-transactions",
        path: "/reports/money-transactions",
        label: "Money Transactions",
        icon: <WalletCards size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewMoneyTransactionsReport",
        },
      },
      // {
      //   id: "loans",
      //   path: "/reports/loans",
      //   label: "Loans",
      //   icon: <HandCoins size={13} />,
      //   requiredPermission: {
      //     section: "reports",
      //     action: "canViewLoansReport"
      //   }
      // },
      {
        id: "Esouq Orders",
        path: "/reports/esouq-orders",
        label: "Esouq Orders",
        icon: <ShoppingBasket size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewEsouqOrdersReport",
        },
      },
      {
        id: "Statements",
        path: "/reports/statements",
        label: "Statements",
        icon: <FileClock size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewStatementsReport",
        },
      },
      {
        id: "demo-users-statements",
        path: "/reports/demo-users-statements",
        label: "Demo Statements",
        icon: <FileClock size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewStatementsReport",
        },
      },
      {
        id: "users-statement",
        path: "/reports/users-statement",
        label: "Users Statement",
        icon: <FileChartColumn size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewDailyUsersStatement",
        },
      },
      {
        id: "users-mismatched-balance",
        path: "/reports/users-mismatched-balance",
        label: "Mismatched Balance",
        icon: <ScaleIcon size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewStatementsReport",
        },
      },
      {
        id: "daily-users-cashback-report",
        path: "/reports/users-cashback",
        label: "Users Cashback",
        icon: <Coins size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewStatementsReport",
        },
      },
      {
        id: "investment-insights",
        path: "/reports/investment-insights",
        label: "Investment Insights",
        icon: <Banknote size={13} />,
        requiredPermission: {
          section: "reports",
          action: "canViewStatementsReport",
        },
      },
    ],
  },
  {
    id: "compliance-transactions",
    path: "/compliance/transactions",
    label: "Transactions",
    icon: <ShieldCheck size={13} />,
    requiredPermission: {
      section: "compliance",
      action: "canViewTransactions",
    },
  },
  {
    id: "compliance-users",
    path: "/compliance/users",
    label: "Users",
    icon: <UsersRound size={13} />,
    requiredPermission: {
      section: "compliance",
      action: "canViewUsers",
    },
  },
  {
    id: "compliance-kyc",
    path: "/compliance/kyc",
    label: "KYC",
    icon: <IdCard size={13} />,
    requiredPermission: {
      section: "compliance",
      action: "canViewKyc",
    },
  },
  {
    id: "clients",
    path: "/clients",
    label: "Clients",
    icon: <Users size={13} />,
    requiredPermission: {
      section: "clientManagement",
      action: "canView",
    },
  },
  {
    id: "referrals",
    label: "Referrals",
    icon: <Gift size={13} />,
    children: [
      {
        id: "referral-clients",
        path: "/referral/clients",
        label: "Clients",
        icon: <Users size={13} />,
        requiredPermission: {
          section: "referralClients",
          action: "canView",
        },
      },
      {
        id: "referral-cashback",
        path: "/referral/cashback",
        label: "Cashback",
        icon: <Coins size={13} />,
        requiredPermission: {
          section: "referralCashback",
          action: "canView",
        },
      },
    ],
  },
  {
    id: "sales-agents",
    label: "Sales",
    icon: <UsersRound size={13} />,
    children: [
      {
        id: "sales-agents-list",
        path: "/sales-agents",
        label: "Agents",
        icon: <Users size={13} />,
        requiredPermission: {
          section: "salesAgents",
          action: "canView",
        },
      },
      {
        id: "sales-agent-commissions",
        path: "/sales-agents/commissions",
        label: "Commissions",
        icon: <Coins size={13} />,
        requiredPermission: {
          section: "salesAgentCommissions",
          action: "canView",
        },
      },
    ],
  },
  {
    id: "neofinancials",
    label: "Neo Financials",
    icon: <WalletMinimal size={13} />,
    children: [
      {
        id: "accountsMapping",
        path: "/neo-financials/accounts-mapping",
        label: "Accounts Mapping",
        icon: <UserRoundPlus size={13} />,
        requiredPermission: {
          section: "neofinancials",
          action: "canView",
        },
      },
      {
        id: "creditdebitaccountsMapping",
        path: "/neo-financials/credit-debit-accounts-mapping",
        label: "Credit/Debit",
        icon: <WalletCards size={13} />,
        requiredPermission: {
          section: "neofinancials",
          action: "canView",
        },
      },
      {
        id: "Fixing Mapping",
        path: "/neo-financials/fixing-mapping",
        label: "Fixing Mapping",
        icon: <AlignHorizontalDistributeCenter size={13} />,
        requiredPermission: {
          section: "neofinancials",
          action: "canView",
        },
      },
      {
        id: "Physical Mapping",
        path: "/neo-financials/physical-mapping",
        label: "Physical Mapping",
        icon: <Omega size={13} />,
        requiredPermission: {
          section: "neofinancials",
          action: "canView",
        },
      },
    ],
  },
  {
    id: "controls",
    label: "Controls",
    icon: <Wrench size={13} />,
    children: [
      ...(import.meta.env.VITE_APP_ENV === "staging" ||
      import.meta.env.VITE_APP_ENV === "development"
        ? [physicalProductsItem]
        : []),
      {
        id: "live-pricing",
        path: "/controls/live-pricing",
        label: "Live Pricing",
        icon: <ChartCandlestick size={13} />,
        requiredPermission: {
          section: "livePricing",
          action: "canView",
        },
      },
      // {
      //   id: "news",
      //   path: "/controls/news",
      //   label: "News",
      //   icon: <Newspaper size={13} />,
      //   requiredPermission: {
      //     section: "news",
      //     action: "canView",
      //   },
      // },
      {
        id: "market-management",
        path: "/controls/market-management",
        label: "Market Management",
        icon: <Clock size={13} />,
        requiredPermission: {
          section: "marketManagement",
          action: "canView",
        },
      },
      {
        id: "market-updates",
        path: "/controls/market-updates",
        label: "Market Updates",
        icon: <TrendingUp size={13} />,
        requiredPermission: {
          section: "marketUpdates",
          action: "canView",
        },
      },
      {
        id: "banks",
        path: "/controls/banks",
        label: "Banks",
        icon: <Landmark size={13} />,
        requiredPermission: {
          section: "banks",
          action: "canView",
        },
      },
      {
        id: "countries",
        path: "/controls/countries",
        label: "Countries",
        icon: <Globe size={13} />,
        requiredPermission: {
          section: "countries",
          action: "canView",
        },
      },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    icon: <Settings size={13} />,
    children: [
      // TODO (15-11-2025): No Need Support Team for Now
      // {
      //   id: "support-teams",
      //   path: "/settings/support-teams",
      //   label: "Support Teams",
      //   icon: <Headphones size={13} />,
      //   requiredPermission: {
      //     section: "supportTeams",
      //     action: "canView"
      //   }
      // },
      {
        id: "offers",
        path: "/settings/offers",
        label: "Offers",
        icon: <Gift size={13} />,
        requiredPermission: {
          section: "offers",
          action: "canView",
        },
      },
      {
        id: "push-notifications",
        path: "/settings/push-notifications",
        label: "Notifications",
        icon: <BellRing size={13} />,
        requiredPermission: {
          section: "pushNotifications",
          action: "canBroadcast",
        },
      },
      {
        id: "app-version-controls",
        path: "/settings/app-version-controls",
        label: "App Version",
        icon: <Rocket size={13} />,
        requiredPermission: {
          section: "appConfigs",
          action: "canView",
        },
      },
      {
        id: "admin-settings",
        path: "/settings/admin-settings",
        label: "Admin",
        icon: <ShieldUser size={13} />,
        requiredPermission: {
          section: "adminManagement",
          action: "canView",
        },
      },
      {
        id: "audit-logs",
        path: "/settings/audit-logs",
        label: "Audit Logs",
        icon: <ScrollText size={13} />,
        requiredPermission: {
          section: "adminManagement",
          action: "canView",
        },
      },
    ],
  },
];
